const AwNextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="ui">
            <a className="right arrow" onClick={onClick} href="#next">
            <i className="aw gt-inverted"><span></span></i>
            </a>
        </div>
    );
}
export default AwNextArrow;